import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng';
import { LoaderService } from 'src/app/services/loader.service';
import { AccessUserInfo, LabActionItemTabDetail, UpComingLabs, UserDetail, UserLocationFacility } from 'src/app/models';
import { CustomDialogService, LabActionItemService, UserService } from 'src/app/services';
import { DialogService } from 'primeng/dynamicdialog';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { CustomDatePipe } from 'src/app/pipes';
import { PreviewLabelComponent } from '../../request/preview-label/preview-label.component';
import { LabRequestHistoryComponent } from '../../request/lab-request-history/lab-request-history.component';
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';

@Component({
  selector: 'bart-upcomming-labs',
  templateUrl: './upcomming-labs.component.html',
  styleUrls: ['./upcomming-labs.component.scss'],
  providers: [DialogService, CustomDialogService,CustomDatePipe]
})
export class UpcommingLabsComponent implements OnInit {
  @Input() selectedFacilityMasterId : number;
  @Input() userFacilities :UserLocationFacility []; 
  @Input() tabDetails:LabActionItemTabDetail 
  @Output() refreshTabCount: EventEmitter<any> = new EventEmitter();
  @ViewChild('dtUpcomingLabTable', { static: false }) dtUpcomingLabTable: Table;
  requestColumnHeader: any[];
  upcomingLabActionItems:UpComingLabs[] = [];
  facilityDisplayName:string="";
  public userInfo: UserDetail;
  public ENUM_WORKFLOW = WorkFlow;
  constructor(
    private _labActionItemService:LabActionItemService,
    private _loaderService: LoaderService,
    public dialogService: CustomDialogService,
    private _userService: UserService,
    private customDatePipe: CustomDatePipe) { 
      this.userInfo = AccessUserInfo.getUserInfo(); 
    }

  ngOnInit() {

    this.requestColumnHeader = [
      { field: 'LabRequestID', header: 'Request ID', display: 'table-cell', width: "20%" },
      { field: 'EquipmentDisplayName', header: 'Model # | Nickname | Serial # | Equipment ID',display: 'table-cell', width: "25%" },      
      { field: 'LastShippingManifestDate', header: 'Last Shipping Manifest Print Date ',display: 'table-cell', width: "20%"},
      { field: 'DueDate', header: 'Due Date', display: 'table-cell', width: "20%" }
    ];   
    this.getUpcomingLabActionItems();
    this.facilityDisplayName=this.userFacilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName;
   //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.FILTER,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "FacilityMasterID",
    value: this.selectedFacilityMasterId,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_GRID_LOADED
  });
  //#endregion
  }

  getUpcomingLabActionItems() {
    this._loaderService.show()
    let getNoLabRequestActionItemsParams = {
      "GETUPCOMINGLABACTIONITEMS": {
        facilitymasterid: this.selectedFacilityMasterId
      },
    }
    this.upcomingLabActionItems = [];
    this._labActionItemService.getUpcomingLabActionItems(JSON.stringify(getNoLabRequestActionItemsParams)).subscribe(data => {
      this.upcomingLabActionItems = data.getUpcomingLabActionItems;
      if(this.upcomingLabActionItems){
        this.upcomingLabActionItems.forEach(item =>
          {
             item.DueDate=this.customDatePipe.transform(item.DueDate,"local","MM/dd/yyyy");
             item.DueDateSort=new Date (this.customDatePipe.transform(item.DueDate,"local","MM/dd/yyyy"));
             item.LastShippingManifestDate=this.customDatePipe.transform(item.LastShippingManifestDate,"local","MM/dd/yyyy HH:mm");
             item.LastShippingManifestDateSort=new Date (this.customDatePipe.transform(item.LastShippingManifestDate,"local","MM/dd/yyyy HH:mm"));
             
          });
      }   
      if(this.upcomingLabActionItems && this.tabDetails.RecordCount!=this.upcomingLabActionItems.length)
      {
        this.tabDetails.RecordCount=this.upcomingLabActionItems.length
      }   
      this._loaderService.hide()

    },
      err => {
        this._loaderService.hide()
      });

  }

  openPreviewLabelPopup(rowData) {
    const ref = this.dialogService.open(PreviewLabelComponent, {
      header: rowData.WorkFlow==this.ENUM_WORKFLOW.HOME?'Home Label Summary':'Label Summary',
      styleClass:"preview-label-summary-popup",
      data:
      {
        labRequestId:rowData.LabRequestID,
        facilityMasterId:this.selectedFacilityMasterId,
        facilityDisplayName:this.facilityDisplayName,
        workFlow:rowData.WorkFlow,
      }
    });
    ref.onClose.subscribe((data) => 
    {     
      this.refreshTabCount.emit();    
    });

     //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "labRequestId",
    value: rowData.LabRequestID,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_GRID_PREVIEW_LABEL_CLICKED
  });
  //#endregion
    
  }

  openHistoryPopup(labRequestId) {
    const ref = this.dialogService.open(LabRequestHistoryComponent, {
      header: 'Lab Request History',
      width: '90%',
      styleClass:'lab-request-history-model-popup',
      data: { 
              labRequestId: labRequestId,
              facilityDisplayName: this.facilityDisplayName,
              selectedFacilityMasterId:this.selectedFacilityMasterId,
              userLocationFacilities:this.userFacilities      
           }  
    });

    //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "LabRequestID",
    value: labRequestId,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_HISTORY_ICON_CLICKED
  });
  //#endregion
  }

  paginate(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_PAGE_NO_CLICKED
    });
    //#endregion
  }
  resetTable(isTableReset:boolean=true) {
    if (this.dtUpcomingLabTable && isTableReset) {
      this.dtUpcomingLabTable.reset();
    }
  }
  onFilter(event)
  {
    this.resetTable(false);
  }
  sortColumn(event) {
    
    this.resetTable(false)
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_COLUMN_SORT
    });
    //#endregion
  }

}
